module.exports = __webpack_public_path__ + "static/media/Calibre-Medium.46b36969.woff2";